import React, { useState, useEffect, useContext } from 'react';
import Select from 'react-select';



function DataFilter(props) {

  const { selectedOption, setFilter, dataOptions, filterBy, placeHolder } = props;

  const onChange = (selectedOption) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [filterBy]: selectedOption?.value
    }))
  }

  return (
    <div >


      <Select
        styles={{
          control: (base) => ({
            ...base,
            height: '31px', // Adjust the height for "sm"
            minHeight: '31px', // Ensures consistency
            fontSize: '0.84rem', // Bootstrap's small font size
          }),
          valueContainer: (base) => ({
            ...base,
            marginTop: -3,
          }),
          clearIndicator: (base) => ({
            ...base,
            marginTop: -3,
          }),
          dropdownIndicator: (base) => ({
            ...base,
            marginTop: -3,
          }),
        }}
        options={dataOptions}
        isSearchable={true}
        required
        placeholder={placeHolder}
        value={selectedOption}
        onChange={onChange}
      />


    </div>
  )
}

export default DataFilter;
